
































































































import {
  Component,
  Vue
} from "@/shared/vuepack";
import { useHsabExpenseEvidenceShoeboxStore } from "@/employee/store/hsabExpenseEvidenceShoebox";
import { useThemeStore } from "@/shared/store/theme";
import { formatMMMDateString } from "@/shared/dateString";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import Paginator from "@/shared/components/ui/Paginator.vue";
import { HsabExpenseEvidenceShoeboxResponse } from "@/shared/types";
import _ from "lodash";
import HsabExpenseForm from "@/employee/components/landing-pages/hsabank/expense/HsabExpenseForm.vue";

@Component({
  components: { HsabExpenseForm, Paginator, GenericLoadingSpinner }
})
export default class HsabExpenseEvidenceShoeboxModal extends Vue {
  shoeboxStore = useHsabExpenseEvidenceShoeboxStore();
  themeStore = useThemeStore();
  showModal = false;
  showExpenseModal = false;
  checkedIds = [];
  checkedShoeboxExpenseEvidence: HsabExpenseEvidenceShoeboxResponse [] = [];

  mounted () {
    this.shoeboxStore.loadPage(1);
  }

  get currentPage () {
    return this.shoeboxStore.currentPageNumber;
  }

  get pageCount () {
    return this.shoeboxStore.totalPageCount;
  }

  get hasPages () {
    return this.shoeboxStore.totalPageCount > 0;
  }

  get loading () {
    return this.shoeboxStore.isCurrentPageLoading;
  }

  get items () {
    _.each(this.shoeboxStore.currentPageItems, x => {
      x.isChecked = _.some(this.checkedIds, id => id === x.hsabExpenseEvidenceShoeboxId);
    });
    return this.shoeboxStore.currentPageItems;
  }

  clearShoeboxImagesCheckboxes (): void {
    this.checkedIds = [];
    this.checkedShoeboxExpenseEvidence = [];
  }

  onSwitchPage (pageNumber: number) {
    this.shoeboxStore.loadPage(pageNumber);
  }

  openModal () {
    this.showModal = true;
    this.shoeboxStore.loadPage(1);
  }

  closeModal () {
    this.showModal = false;
    this.clearShoeboxImagesCheckboxes();
  }

  openExpenseModal () {
    this.showExpenseModal = true;
    this.showModal = false;
  }

  closeExpenseModal () {
    this.showExpenseModal = false;
    this.clearShoeboxImagesCheckboxes();
  }

  createExpense () {
    this.openExpenseModal();
  }

  openFile (item: HsabExpenseEvidenceShoeboxResponse) {
    this.shoeboxStore.OpenAttachment(item.hsabExpenseEvidenceShoeboxId);
  }

  onCheckedChanged (isChecked: boolean, item: HsabExpenseEvidenceShoeboxResponse) {
    if (isChecked) {
      this.checkedIds.push(item.hsabExpenseEvidenceShoeboxId);
      this.checkedShoeboxExpenseEvidence.push(item);
    } else {
      this.checkedIds = _.filter(this.checkedIds, x => x !== item.hsabExpenseEvidenceShoeboxId);
      this.checkedShoeboxExpenseEvidence = _.filter(this.checkedShoeboxExpenseEvidence, x => x.hsabExpenseEvidenceShoeboxId !== item.hsabExpenseEvidenceShoeboxId);
    }
  }

  formatDateForDisplay (date) {
    return formatMMMDateString(date);
  }
}
